import log from 'loglevel'

// Set log level to the level specified in .env
const level = process.env.VUE_APP_LOG_LEVEL || 'silent'
log.setLevel(level)
log.info("Log-Level is set to '" + level + "'")
